var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('gas',{staticClass:"gas"}),_c('div',{staticClass:"expect"},[_vm._v("功能二：敬请期待")]),_c('div',{staticClass:"expect"},[_vm._v("功能三：敬请期待")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }